const common = {
  // Actions
  save: 'Opslaan',
  cancel: 'Annuleren',
  delete: 'Verwijderen',
  edit: 'Bewerken',
  back: 'Terug',
  next: 'Volgende',
  finish: 'Afronden',
  continue: 'Ga door',
  send: 'Versturen',
  download: 'Download',
  search: 'Zoeken',
  confirm: 'Bevestigen',

  // Auth
  login: 'Inloggen',
  logout: 'Uitloggen',
  register: 'Registreer',

  // Entities
  client: 'Klant',
  clients: 'Klanten',
  company: 'Bedrijf',
  invoice: 'Factuur',
  invoices: 'Facturen',
  quotation: 'Offerte',
  quotations: 'Offertes',
  product: 'Product',
  products: 'Producten',
  settings: 'Instellingen',
  dashboard: 'Dashboard',

  // Status
  active: 'Actief',

  // Misc UI
  changes_saved: 'Wijzigingen opgeslagen',
  loading: 'Laden...',
}

export default common
